import { useEffect, useState, useCallback } from "react"
import { Container, Card } from "react-bootstrap"
import { useHistory } from "react-router"
import { CentradoVertical } from "../Utilidades"
import { useApi } from "ApiHooks"
import { storageFactory } from "storage-factory"
import { useBlockUI } from "Context/BlockUIContext"
import { ListBox } from "Components/ListBox"
import React from "react"
import './SelectDeclarante.css'
import { tokenStorage } from "TokenStorage"

type Empresa = {
    cuit: string
    nombre: string
    PorDefecto?: boolean
}

export function SelectDeclarante() {
    const api = useApi()
    const history = useHistory()
    const storage = storageFactory(() => localStorage)

    const { showBlock, hideBlock } = useBlockUI()

    const [empresas, setEmpresas] = useState<Empresa[]>([])

    const handleSelect = useCallback(
        (empresa: Empresa) => {
            storage.setItem("declaranteSeleccionado", empresa.cuit)
            storage.setItem("nombreDeclaranteSeleccionado", empresa.nombre)
            history.replace("/lotes")
        },
        [history, storage]
    )

    const empresaPorDefecto = empresas.find(e => e.PorDefecto)?.cuit

    useEffect(() => {
        const cargarEmpresas = async () => {
            showBlock("Cargando empresas...")

            try {
                const empresasObtenidas = await api.getDespachantesUsuario()
                setEmpresas(empresasObtenidas)
                if (empresasObtenidas?.length === 1) {
                    handleSelect(empresasObtenidas[0])
                }
            } catch (error) {
                if (!api.isCancel(error)) {
                    console.log("Error al cargar empresas")
                }
                tokenStorage.setAccessToken('')
                tokenStorage.setRefreshToken('')
                storage.removeItem('declaranteSeleccionado')
                window.location.replace('/login')
            } finally {
                hideBlock()
            }
        }

        cargarEmpresas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <CentradoVertical>
            <Container>
                <h2 className="mb-4 text-center">Seleccionar un Declarante</h2>

                <div className="d-flex flex-column gap-3">
                    <ListBox
                        list={empresas}
                        itemKey="cuit"
                        selectedKey={empresaPorDefecto}
                        onSelect={handleSelect}
                        render={(empresa: Empresa) => (
                            <Card
                                className="shadow-sm empresa-card"
                            >
                                <Card.Body className="py-3 bg-white">
                                    <h5 className="mb-1 mt-1 fw-bold">{empresa.nombre}</h5>
                                    <div className="text-muted">CUIT: {empresa.cuit}</div>
                                </Card.Body>
                            </Card>
                        )}
                    />
                </div>
            </Container>
        </CentradoVertical>
    )
}
